export default "__VITE_ASSET__CSqHEZi2__"